<template>
  <Paginator 
    :rows="perPage"
    :total-records="totalRows"
    :first="firstRecord"
    class="mt-10"
    @page="onPageChange"
  />
</template>

<script>
import Paginator from 'primevue/paginator';

export default {
  name: "SohaPagination",
  components: {
    Paginator
  },
  props: {
    perPage: {
      type: Number,
      default: 10
    },
    totalRows: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {
    firstRecord() {
      return (this.currentPage - 1) * this.perPage;
    }
  },
  methods: {
    onPageChange(event) {
      const newPage = Math.floor(event.first / this.perPage) + 1;
      this.$emit("onPageChange", {
        ...event,
        page: newPage,
        currentPage: newPage
      });
    }
  }
};
</script>